import {Button, Grid, Typography} from "@material-ui/core";
import SortingDropdown from "../../../../../../../../../../shared/components/sorting-dropdown/SortingDropdown";
import DeviceDetailsTable from "../../device-details-tables/DeviceDetailsTable";
import {useSelector} from "react-redux";
import {useState} from "react";
import {headCellsConsegnati, sortingCriteriaConsegnati} from "../../device-details-tables/DeviceDetailsTableHelper";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";
import {routePaths} from "../../../../../../../../../../shared/utils/constants/routePaths";

const ConsegnatiTable = (props) => {
    const history = useHistory();
    const data = useSelector(state => state.contrattoDigitaleReducer.deviceDetailsConsegnati.data.deviceConsegnatiList)
    const [sort, setSort] = useState(`${sortingCriteriaConsegnati[0].value},desc`)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)

    const handleChangeData = (page, rowsPerPage) => {
        setPage(page)
        setRowsPerPage(rowsPerPage)
    }
    const handleClick = () => {
        history.push(routePaths.DEVICE)
    }

    const handleSortingChange = (value) => {
        setSort(value)
    }

    return (
        <>
            <Grid item xs={12}>
                <Typography variant={"h6"}>Device consegnati</Typography>
            </Grid>
            <Grid item container justifyContent={"space-between"}>
                <Grid item>
                    <SortingDropdown sortingValue={sort}
                                     changeSortingCriteria={handleSortingChange}
                                     sortingCriteria={sortingCriteriaConsegnati}/>
                </Grid>
                <Grid item>
                    <Button variant="text"
                            color="primary"
                            onClick={handleClick}>vai alla sezione device</Button>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <DeviceDetailsTable tableData={data}
                                    order={sort}
                                    type="Consegnati"
                                    headCells={headCellsConsegnati}
                                    loading={props.loading}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    count={data.length}
                                    changeData={handleChangeData}
                />
            </Grid>
        </>
    )
}

ConsegnatiTable.propTypes = {
    loading: PropTypes.bool.isRequired
}

export default ConsegnatiTable;